import { render, staticRenderFns } from "./PrivateLib.vue?vue&type=template&id=47d7ab18&scoped=true"
import script from "./PrivateLib.vue?vue&type=script&lang=js"
export * from "./PrivateLib.vue?vue&type=script&lang=js"
import style0 from "./PrivateLib.vue?vue&type=style&index=0&id=47d7ab18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7ab18",
  null
  
)

export default component.exports